import Image from "next/image";
import { Br } from "@/components/molecules/Br";

export const AiDrivenSupport = () => {
  return (
    <div className="col-span-1 space-y-4 md:space-y-6">
      <figure className="relative block aspect-[16/9] w-full overflow-hidden rounded-lg md:aspect-[21/9]">
        <Image
          src="/ai-driven-support-banner.png"
          alt="AI駆動化伴走支援"
          quality={90}
          layout="fill"
          objectFit="cover"
        />
      </figure>
      <div className="space-y-4 px-6 py-2 sm:px-8 md:px-12 md:py-4 lg:py-5">
        <div className="space-y-3">
          <h3 className="font-bold text-pri fluid-text-[18px,26px]">
            AI駆動化伴走支援
          </h3>
          <p className="font-bold text-ter fluid-text-[14px,18px]">
            戦略だけで終わらない。
            <Br sp />
            「動くもの」を一緒に作る伴走型支援
          </p>
        </div>
        <div className="space-y-4 leading-comfort text-txt-base fluid-text-[14px,18px]">
          <p>
            コンサルティングファームのような「戦略提案だけ」では終わりません。
            <Br sp />
            受託開発で培った実装力を活かし、
            <Br sp />
            お客様と一緒に「実際に業務で役立つもの」を作り上げます。
          </p>
          <div className="space-y-2">
            <h4 className="font-bold text-ter fluid-text-[13px,17px]">
              6つの支援領域
            </h4>
            <ul className="space-y-2">
              <li className="flex items-start gap-2">
                <span className="mt-1 shrink-0 text-ter">•</span>
                <span>
                  <strong>ナレッジ提供・教育支援</strong>：AI活用の最新トレンド共有、社内研修の実施
                </span>
              </li>
              <li className="flex items-start gap-2">
                <span className="mt-1 shrink-0 text-ter">•</span>
                <span>
                  <strong>業務再設計支援</strong>：AI活用を前提とした業務プロセスの再設計
                </span>
              </li>
              <li className="flex items-start gap-2">
                <span className="mt-1 shrink-0 text-ter">•</span>
                <span>
                  <strong>ツール選定支援</strong>：最適なAIツールの選定と連携設計
                </span>
              </li>
              <li className="flex items-start gap-2">
                <span className="mt-1 shrink-0 text-ter">•</span>
                <span>
                  <strong>ハンズオン・フォローアップ</strong>：実践的なトレーニングと定期フォロー
                </span>
              </li>
              <li className="flex items-start gap-2">
                <span className="mt-1 shrink-0 text-ter">•</span>
                <span>
                  <strong>AI駆動開発伴走</strong>：受託開発のノウハウで「動くもの」を一緒に構築
                </span>
              </li>
              <li className="flex items-start gap-2">
                <span className="mt-1 shrink-0 text-ter">•</span>
                <span>
                  <strong>AI活用運用体制構築</strong>：社内推進体制の設計とガバナンス策定
                </span>
              </li>
            </ul>
          </div>
          <a
            href="https://solution.tocca.systems/solutions/ai-driven-support"
            target="_blank"
            rel="noopener noreferrer"
            className="block rounded-lg bg-bgc-dark p-4 md:p-5 transition-opacity hover:opacity-80"
          >
            <p className="text-center font-bold text-pri fluid-text-[13px,17px]">
              詳しくはこちら（ソリューションサイト）
            </p>
          </a>
        </div>
      </div>
    </div>
  );
};
